module.exports = __webpack_public_path__ + "img/person-holding-white-nicard.aad22ba6.jpg";